import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'; 
import LazyLoad from 'react-lazyload'

import { dayRemaining, dateProgression, strDateToFr, urlToHost } from "../../utilities/FrontFunctions/AoxFrontFunctions"
import { CONST_challengeStateTypes } from "../../data/const"

import ObjProgressBar from "./ObjProgressBar";
import ObjConditionChallenge from '../inc/ObjConditionChallenge';
import ObjChallengeGainLevel from './ObjChallengeGainLevel'
import ObjChallengeGainLevelVentes from './ObjChallengeGainLevelVentes'

class ObjPushChallenge extends Component {
	constructor(props) {
		super(props)
		this.state = {
		}
	}
	render() {
		const {participation, isManager, pageChallengeDetail} = this.props;
		const DayRemainingToDeclare = dayRemaining(participation.Challenge.Challenge_ToDeclareDate);
		const DayRemainingToDispatch = dayRemaining(participation.Challenge.Challenge_ToDispatchDate);
		
		return (
			<div className={`obj_challenge${this.state.active ? ' is-expanded' : ''} ${CONST_challengeStateTypes[participation.ParticipationStateType_Code].css}`}>
                <div className="ctn_header-title">
                    <span>{participation.ParticipationStateType_Name}</span>
                </div>

				<div className="ctn_row">
					<div className="ctn_text">
						{(() => {switch (participation.ParticipationStateType_Code) {
							case 'STATE_TYPE_TO_DECLARE' : return DayRemainingToDeclare > -1 &&
								<div className="obj_temps_restant">
									<div className="obj_jours-restant">
										{	DayRemainingToDeclare===0
											?<p><strong>Dernier jour</strong></p>
											:<><span>{DayRemainingToDeclare}</span><p><strong>jours restants</strong> jusqu'au {strDateToFr(participation.Challenge.Challenge_ToDeclareDate)}</p></>
										}
									</div>
									{ 	DayRemainingToDeclare<=10
										? <div>
											<div className="obj_progress-bar-challenge var_attention">
												<ObjProgressBar pctProgress={dateProgression(participation.Challenge.Challenge_EndDate, participation.Challenge.Challenge_ToDeclareDate)}/>
											</div>
											<div className="obj_jours-restant-info">
												<p>Déclaration impossible une fois la date dépassée !</p>
											</div>
										</div>
										: <div className="obj_progress-bar-challenge">
											<ObjProgressBar pctProgress={dateProgression(participation.Challenge.Challenge_EndDate, participation.Challenge.Challenge_ToDeclareDate)}/>
										</div>
									}
								</div>
							case 'STATE_TYPE_TO_DISPATCH' : return DayRemainingToDispatch > -1 &&
								<div className="obj_temps_restant">
									<div className="obj_jours-restant">
										{	DayRemainingToDispatch===0
											?<p><strong>Dernier jour</strong></p>
											:<><span>{DayRemainingToDispatch}</span><p><strong>jours restants</strong> jusqu'au {strDateToFr(participation.Challenge.Challenge_ToDispatchDate)}</p></>
										}
									</div>
									{ 	DayRemainingToDispatch<=10
										? <div>
											<div className="obj_progress-bar-challenge var_attention">
												<ObjProgressBar pctProgress={dateProgression(participation.Challenge.Challenge_ToDeclareDate, participation.Challenge.Challenge_ToDispatchDate)}/>
											</div>
											<div className="obj_jours-restant-info">
												<p>Répartition impossible une fois la date dépassée !</p>
											</div>
										</div>
										: <div className="obj_progress-bar-challenge">
											<ObjProgressBar pctProgress={dateProgression(participation.Challenge.Challenge_ToDeclareDate, participation.Challenge.Challenge_ToDispatchDate)}/>
										</div>
									}
								</div>
							default : return <></>
						}})()}

                        <div className="obj_text-header">
                            <p className="t_title">{participation.Challenge.Challenge_Title}</p>
                            <p className="t_date">Du {strDateToFr(participation.Challenge.Challenge_StartDate)} au {strDateToFr(participation.Challenge.Challenge_EndDate)}</p>

                            {isManager && participation.ParticipationStateType_Code === 'STATE_TYPE_TO_DISPATCH' && <>
                                {participation.Participation_Gain &&
                                    <p className="t_desc"><strong>{participation.Participation_Gain}€</strong> à répartir</p>
                                }
                            </>}
                            {isManager && participation.ParticipationStateType_Code === 'STATE_TYPE_FINISHED' && <>
                                {participation.ParticipationState_Code === 'STATE_DECLARATION_DATE_PASSED' ? 
                                    <p className="t_desc">date de déclaration dépassée</p>
                                : participation.Challenge.Challenge_Type === 'PRIVATE_INTER_PDV' ? 
                                    <></>
                                : ! participation.Participation_Gain ? 
                                    <p className="t_desc">aucun gain remporté</p>
                                : participation.Participation_Gain === 0 ? 
                                    <p className="t_desc"><strong>0€</strong> remporté</p>
                                : 
                                    <p className="t_desc"><strong>{participation.Participation_Gain}€</strong> remportés</p>
                                }
                            </>}

                            {participation.ParticipationStateType_Code === 'STATE_TYPE_TO_DECLARE' ?
                                <a className="obj_btn_challenge" href={`${pageChallengeDetail?.url}?id=${participation.Challenge.Challenge_Id}`}>
                                    {isManager?"Déclarer":"Voir le détail"}
                                </a>
                            : participation.ParticipationStateType_Code === 'STATE_TYPE_TO_DISPATCH' ?
                                <a className="obj_btn_challenge" href={`${pageChallengeDetail?.url}?id=${participation.Challenge.Challenge_Id}`}>
                                    {isManager?"Répartir":"Voir le détail"}
                                </a>
                            : participation.ParticipationStateType_Code === 'STATE_TYPE_FINISHED' ?
                                <>{isManager && <a className="obj_btn_challenge" href={`${pageChallengeDetail?.url}?id=${participation.Challenge.Challenge_Id}`}>
                                    Voir le détail
                                </a>}</>
                            : 
                                <a className="obj_btn_challenge" href={`${pageChallengeDetail?.url}?id=${participation.Challenge.Challenge_Id}`}>
                                    Voir le détail
                                </a>
                            }
                        </div>

                        {participation.Challenge.Challenge_Category === "UNITE" && <ObjChallengeGainLevel participation={participation}/>}
                        {participation.Challenge.Challenge_Category === "PALIER" && <ObjChallengeGainLevelVentes paliers={participation.Challenge.Paliers}/>}

						<button className="obj_btn_condition_challenge-detail" onClick={ () => this.setState({active: !this.state.active}) }>
							<span>voir les Conditions du challenge</span>
						</button>

						<div className="ctn_conditions-expand">
							<ObjConditionChallenge participation={participation} isManager={isManager}/>
						</div>
					</div>

					<div className="ctn_image">
						<div className="ctn_visuel fade-in">
							<LazyLoad>
								<img src={urlToHost(participation.Challenge.Challenge_MediaUrl)} alt={participation.Challenge.Challenge_MediaAlt}/>
							</LazyLoad>
						</div>

						<div className="ctn_logo">
							<LazyLoad>
								<img src={urlToHost(participation.Challenge.Brand.Brand_LogoUrl)} alt={participation.Challenge.Brand.Brand_Name}/>
							</LazyLoad>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default withTranslation()(ObjPushChallenge)